import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { QuestionCircleOutlined } from '@ant-design/icons';
import s from '../../s.module.less';

interface IQuestionNodeData {
    label?: string;
    type: 'question';
    questionId?: string;
    questionTitle?: string;
    answerCondition?: string;
}

const QuestionNode: React.FC<NodeProps<IQuestionNodeData>> = ({ data, selected }) => {
    return (
        <div className={`${s.questionNode} ${selected ? 'selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Left}
                id="left"
                style={{ background: '#1890ff' }}
            />
            <Handle
                type="source"
                position={Position.Right}
                id="right"
                style={{ background: '#1890ff' }}
            />
            <div className={s.nodeContent}>
                <QuestionCircleOutlined className={s.nodeIcon} />
                <div className={s.nodeLabel}>
                    {data.questionTitle || data.label || 'Question'}
                </div>
                {data.answerCondition && (
                    <div className={s.nodeSubLabel}>
                        {data.answerCondition}
                    </div>
                )}
            </div>
        </div>
    );
};

export default QuestionNode;
